export enum AlarmLifetimeThresholdEnum {
	UntilConditionIsTrue,
	UntilUserAcknowledged,
	UntilUserValidatedAsRealFalse,
}
